<template>
  <div :class="{ trial: isTrialUser && !device.isTrialDevice }">
    <div v-if="!isOpen" class="device-item">
      <div
        v-if="isTrialUser && !device.isTrialDevice"
        class="pro-ribbon--grid-view"
      ></div>
      <img
        v-if="isTrialUser && !device.isTrialDevice"
        class="pro-ribbon-icon--grid-view"
        src="@/assets/images/crown.svg"
        alt="pro"
      />
      <div class="device-item__left">
        <div class="status">
          <div class="status-ball" :class="currentStatus(device.status)"></div>
          <span class="text-xs font-bold dark:text-secondary-300">{{
            $t(mapStatus(device.status))
          }}</span>
        </div>
        <div class="flex gap-1 flex-col">
          <p
            class="text-xs font-semibold text-secondary-base dark:text-primary-white"
          >
            {{ device.deviceName }}
          </p>
          <p
            class="text-xs font-semibold text-secondary-400 dark:text-greyscale-500"
          >
            {{ device.deviceBrand }}
          </p>
        </div>
        <div class="device-info">
          <p>{{ $t("device.spec.version") }}:</p>
          <p>{{ device.osVersion }}</p>
          <p>{{ $t("device.spec.resolution") }}:</p>
          <p>{{ device.resolution }}</p>
          <p>{{ $t("device.spec.size") }}:</p>
          <p>{{ device.screenSize }}</p>
        </div>

        <div @click="openDetail(device)" class="info-button">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 13"
            fill="none"
          >
            <path
              d="M6.50399 5.12502L6.50399 8.62094H5.49601L5.49601 5.12502H6.50399ZM6.50399 3.12507V4.12105H5.49601V3.12507H6.50399ZM6 12.1249C6.80124 12.1302 7.59502 11.9707 8.33195 11.6561C9.77889 11.0532 10.929 9.90309 11.5319 8.45615C11.8461 7.71941 12.0054 6.92592 11.9999 6.125C12.0052 5.32376 11.8457 4.52998 11.5311 3.79305C10.9282 2.34611 9.77809 1.19597 8.33115 0.593127C7.59441 0.278923 6.80092 0.119625 6 0.125138C5.19876 0.119768 4.40498 0.279341 3.66805 0.593927C2.22111 1.19677 1.07097 2.34691 0.468127 3.79385C0.153923 4.53059 -0.00537491 5.32408 0.000138283 6.125C-0.00523186 6.92624 0.154341 7.72002 0.468927 8.45695C1.07177 9.90389 2.22191 11.054 3.66885 11.6569C4.40559 11.9711 5.19908 12.1304 6 12.1249Z"
              fill="#21242B"
            />
          </svg>
          <span class="dark:text-greyscale-500">{{
            $t("button.devicelist.info")
          }}</span>
        </div>
      </div>
      <div class="device-item__right">
        <div class="photo">
          <img class="device-image" alt="device" :src="getImageUrl" />
        </div>
        <div class="photo-tile"></div>
        <Button
          @click="goToDevice"
          :disabled="!isEnabled"
          class="launch-button success"
        >
          <div class="flex gap-1 items-center">
            <svg
              v-if="isTrialUser && !device.isTrialDevice"
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.7 18.98H7.29995C6.87995 18.98 6.40995 18.65 6.26995 18.25L2.12995 6.66999C1.53996 5.00999 2.22996 4.49999 3.64996 5.51999L7.54995 8.30999C8.19995 8.75999 8.93995 8.52999 9.21995 7.79999L10.98 3.10999C11.54 1.60999 12.47 1.60999 13.03 3.10999L14.79 7.79999C15.07 8.52999 15.81 8.75999 16.45 8.30999L20.11 5.69999C21.67 4.57999 22.42 5.14999 21.78 6.95999L17.74 18.27C17.59 18.65 17.12 18.98 16.7 18.98Z"
                stroke="#fff"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                opacity="0.34"
                d="M6.5 22H17.5"
                stroke="#fff"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                opacity="0.34"
                d="M9.5 14H14.5"
                stroke="#fff"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span class="launch-button-text">{{ launchButtonText }}</span>
          </div>
        </Button>
      </div>
    </div>
    <div v-if="isOpen" class="device-item--list-view">
      <div
        v-if="isTrialUser && !device.isTrialDevice"
        class="pro-ribbon--list-view"
      ></div>
      <img
        v-if="isTrialUser && !device.isTrialDevice"
        class="pro-ribbon-icon--list-view"
        src="@/assets/images/crown.svg"
        alt="pro"
      />
      <div class="device-item--list-view-wrapper">
        <div
          class="status-ball --list-view"
          :class="currentStatus(device.status)"
        ></div>
        <div class="device-photo--list-view m-auto">
          <img class="device-image" alt="device" :src="getImageUrl" />
        </div>
        <div class="flex gap-1 flex-col">
          <p
            class="text-xs font-semibold text-secondary-base-100 dark:text-primary-white"
          >
            {{ device.deviceName }}
          </p>
          <p
            class="text-xs font-semibold text-secondary-400 dark:text-greyscale-500"
          >
            {{ device.deviceBrand }}
          </p>
        </div>
        <div class="status--list-view">
          <div class="status-ball" :class="currentStatus(device.status)"></div>
          <span class="status--list-view__title text-secondary-base">{{
            $t(mapStatus(device.status))
          }}</span>
        </div>
        <div class="m-auto">
          <p class="status--list-view__title font-bold text-secondary-base-100">
            {{ device.osVersion }}
          </p>
        </div>
        <div class="m-auto">
          <p class="status--list-view__title font-bold text-secondary-base-100">
            {{ device.resolution }}
          </p>
        </div>
        <div class="m-auto">
          <p class="status--list-view__title font-bold text-secondary-base-100">
            {{ device.screenSize }}
          </p>
        </div>
        <div @click="openDetail(device)" class="device-info-button m-auto">
          <span class="status--list-view__title font-semibold">
            {{ $t("button.devicelist.info") }}
          </span>
        </div>
        <div class="m-auto">
          <Button
            @click="goToDevice"
            :disabled="!isEnabled"
            class="launch-button--list-view success"
          >
            <div class="flex gap-1 items-center">
              <svg
                v-if="isTrialUser && !device.isTrialDevice"
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.7 18.98H7.29995C6.87995 18.98 6.40995 18.65 6.26995 18.25L2.12995 6.66999C1.53996 5.00999 2.22996 4.49999 3.64996 5.51999L7.54995 8.30999C8.19995 8.75999 8.93995 8.52999 9.21995 7.79999L10.98 3.10999C11.54 1.60999 12.47 1.60999 13.03 3.10999L14.79 7.79999C15.07 8.52999 15.81 8.75999 16.45 8.30999L20.11 5.69999C21.67 4.57999 22.42 5.14999 21.78 6.95999L17.74 18.27C17.59 18.65 17.12 18.98 16.7 18.98Z"
                  stroke="#fff"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  opacity="0.34"
                  d="M6.5 22H17.5"
                  stroke="#fff"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  opacity="0.34"
                  d="M9.5 14H14.5"
                  stroke="#fff"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span class="launch-button-text">{{ launchButtonText }}</span>
            </div>
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from "@/mixins";
import { mapActions, mapGetters } from "vuex";
import Button from "@/components/Button";

export default {
  name: "DeviceItem",
  mixins: [mixin],
  components: { Button },
  props: {
    device: Object,
    isTrialDevice: Boolean,
    isOpen: Boolean,
  },
  computed: {
    ...mapGetters(["isTrialUser"]),
    getImageUrl() {
      return require(`@/assets/images/devices/${this.device.iconTag}`);
    },
    isEnabled() {
      return this.device.status === 1;
    },
    launchButtonText() {
      return this.isTrialUser && !this.device.isTrialDevice
        ? this.$t("button.devicelist.pro")
        : this.$t("button.devicelist.launch");
    },
  },
  methods: {
    ...mapActions(["emitMixPanelEvent"]),
    goToDevice() {
      if ((!this.isTrialUser || this.device.isTrialDevice) && this.isEnabled) {
        this.emitMixPanelEvent({
          event: "deviceLaunch",
          data: {
            launchDeviceOS: this.device.deviceOs,
            launchDeviceBrand: this.device.deviceBrand,
            launchDeviceModel: this.device.deviceModel,
            launchDeviceUDID: this.device.deviceToken,
            launchDeviceResolution: this.device.resolution,
            launchDeviceLocation: "DeviceList",
          },
        });
        this.$router.push({
          name:
            this.device.deviceOs === "android"
              ? "DeviceLauncherAndroid"
              : "DeviceLauncherIos",
          params: { deviceId: this.device.id },
        });
      }
    },
    openDetail(device) {
      this.$emit("open-detail", device);
    },
  },
};
</script>
<style lang="css">
@import "index.module.css";
</style>
